<div
    *ngIf="! properties.LOGGED_IN"
    class="right-side-bar-heading">
    USER ACTIONS
</div>
<canano-login
    *ngIf="! properties.LOGGED_IN"
></canano-login>
